export const FETCH_DASHBOARD = "[GROUPADMIN] FETCH_DASHBOARD";
export const FETCH_DASHBOARD_START = "[GROUPADMIN] FETCH_DASHBOARD_START";
export const FETCH_DASHBOARD_SUCCESS = "[GROUPADMIN] FETCH_DASHBOARD_SUCCESS";
export const FETCH_DASHBOARD_ERROR = "[GROUPADMIN] FETCH_DASHBOARD_ERROR";

export const fetchGroupAdminDashboard = () => {
    return {
        type: FETCH_DASHBOARD
    };
};
